import {
  Directive,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Subscription } from "rxjs";
import { LoadingIndicationService } from "../services/loading-indication.service";

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({
    selector: "[loadingIndication]",
    standalone: false
})
export class LoadingIndicationDirective implements OnInit, OnDestroy {
  constructor(
    private loadingIndicationService: LoadingIndicationService,
    private element: ElementRef
  ) {}

  subscribe: Subscription;

  @Input() loadingIndication: string;

  clicked = false;

  @HostBinding("class.-isLoading") isLoading = false;

  @HostListener("click") onClick() {
    this.clicked = true;
  }

  ngOnInit() {
    if (this.loadingIndication) {
      this.subscribe =
        this.loadingIndicationService.activeRequestUrls$.subscribe((urls) => {
          if (this.clicked) {
            const state = urls.some((url) => {
              return url
                .toLowerCase()
                .includes(this.loadingIndication.toLowerCase());
            });
            this.isLoading = state;
            this.element.nativeElement.disabled = state;
            this.clicked = state;
          }
        });
    }
  }

  ngOnDestroy() {
    if (this.subscribe) {
      this.subscribe.unsubscribe();
    }
  }
}
